function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MarkdownIt = require('markdown-it'); // markdown-it plugins


var emoji = require('markdown-it-emoji'); // const checkbox = require('markdown-it-task-checkbox');


var linkAttributes = require('markdown-it-link-attributes');

var implicitFigures = require('markdown-it-implicit-figures');

var mark = require('markdown-it-mark');

var ins = require('markdown-it-ins');

var abbr = require('markdown-it-abbr');

var deflist = require('markdown-it-deflist');

var video = require('markdown-it-video');

function createParser() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (_typeof(options) !== 'object') {
    throw new TypeError('The markdown parser options must be an object.');
  } // Initialize the MD parser and apply plugins


  var parser = new MarkdownIt(Object.assign({
    html: false,
    breaks: true,
    linkify: true,
    xhtmlOut: true,
    typographer: true,
    langPrefix: 'language-'
  }, options));
  parser.use(emoji); // parser.use(checkbox);

  parser.use(linkAttributes, {
    target: '_blank',
    rel: 'nofollow'
  });
  parser.use(implicitFigures);
  parser.use(mark);
  parser.use(ins);
  parser.use(abbr);
  parser.use(deflist);
  parser.use(video, options.video || {});
  return function parse(html) {
    return parser.render(html);
  };
}

module.exports = createParser;